import { faGrid, faList } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useSetState } from '@domain-group/react-hooks'
import { Box, DashboardModule, Link } from '@domain-group/suit-theme'

import useSavedArtworkPages from '@hooks/useSavedArtworkPages'

import ListView from '../Views/ListView'
import GridView from '../Views/GridView'

type SavedArtworkPagesProps = {
  pageFilters: any,
  selectedAgencyId: number,
}

type DefaultState = {
  gridView: boolean,
}

const defaultState: DefaultState = {
  gridView: false,
}

const SavedArtworkPages = (props: SavedArtworkPagesProps) => {
  const { pageFilters, selectedAgencyId } = props

  const [state, setState] = useSetState(defaultState)
  const { gridView } = state

  const savedArtworksPayload = useSavedArtworkPages({
    filters: { agency_id: selectedAgencyId, ...pageFilters },
    performHttpRequests: true,
    requestOptions: {
      include_saved_artwork_page_preview: true,
      include_saved_artwork_page_user: true,
    },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredSavedArtworkPages,
    filteredSavedArtworkPagesCount,
    hasFilteredSavedArtworkPages,
    loading,
  } = savedArtworksPayload

  const Component = gridView ? GridView : ListView

  return (
    <Box marginBottom="large">
      <DashboardModule
        boxProps={{ borderBottom: `${loading ? 'none' : ''}` }}
        contentBoxProps={{ flexDirection: 'column' }}
        headerRight={(
          <Link greyLink onClick={() => setState({ gridView: !gridView })}>
            <FontAwesomeIcon icon={gridView ? faList : faGrid} />
          </Link>
        )}
        loading={loading}
        title="Saved Artwork Pages"
      >
        {!loading && hasFilteredSavedArtworkPages && (
          <Component entities={filteredSavedArtworkPages} />
        )}

        {!loading && !hasFilteredSavedArtworkPages && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Saved ArtworkPages present
            </DashboardModule.BlankState.Title>
          </DashboardModule.BlankState>
        )}

        <DashboardModule.LoadMoreFooter
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredSavedArtworkPagesCount}
          loading={loading}
        />
      </DashboardModule>
    </Box>
  )
}

export default SavedArtworkPages
